<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <v-row dense class="mb-4">
        <v-col cols="12" md="3">
          <v-card class="rounded-lg shadow-sm" color="blue darken-2" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-2">อัตรากำลังทั้งหมด</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.total }} <small class="caption">อัตรา</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="blue darken-1">
                <v-icon size="30">mdi-briefcase-account</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="rounded-lg shadow-sm" color="success" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-2">สถานะ : ว่าง</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.vacant }} <small class="caption">อัตรา</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="green darken-1">
                <v-icon size="30">mdi-check-circle-outline</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="rounded-lg shadow-sm" color="orange darken-1" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-2">สถานะ : ถูกจอง/มีคนลง</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.booked }} <small class="caption">อัตรา</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="orange darken-3">
                <v-icon size="30">mdi-account-lock</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="rounded-lg shadow-sm" color="teal darken-2" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-2">สายการสอน</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ stats.teacher }} <small class="caption">อัตรา</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="teal darken-1">
                <v-icon size="30">mdi-human-male-board</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-format-list-checks"
        title="จัดการข้อมูลอัตรากำลังรับย้าย"
        color="primary"
        class="px-5 py-3"
      >
        <v-card flat class="grey lighten-5 rounded-lg mb-4 pa-4">
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 10px;">
              <v-btn small rounded color="primary" @click="man_powerAdd()">
                <v-icon left>mdi-plus-circle</v-icon> เพิ่มตำแหน่ง
              </v-btn>
              <v-btn
                small
                rounded
                color="success"
                outlined
                @click="exportToExcel"
              >
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>
              <v-btn
                small
                rounded
                color="info"
                outlined
                href="#/admin/print_report_manpower"
                target="_blank"
              >
                <v-icon left>mdi-printer</v-icon> พิมพ์รายงาน
              </v-btn>

              <v-divider vertical class="mx-2"></v-divider>

              <v-btn small rounded color="indigo" dark @click="man_powerCSV()">
                <v-icon left>mdi-file-import</v-icon> นำเข้า CSV
              </v-btn>
              <v-btn
                small
                rounded
                color="warning"
                dark
                @click="man_powerReplace()"
              >
                <v-icon left>mdi-account-search</v-icon> ตรวจสอบซ้ำ
              </v-btn>
              <v-btn
                small
                rounded
                color="error"
                outlined
                @click="man_powerClear()"
              >
                <v-icon left>mdi-delete-sweep</v-icon> ล้างข้อมูลทั้งหมด
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา (สถานศึกษา, ตำแหน่ง, เลขที่...)"
                outlined
                dense
                rounded
                hide-details
                class="bg-white"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="man_powers"
          :search="search"
          :loading="loading"
          class="elevation-0 custom-table"
        >
          <template v-slot:item.status_booking="{ item }">
            <v-chip v-if="item.status_booking" color="warning" small dark label>
              <v-icon left x-small>mdi-lock</v-icon>
              {{ item.status_booking }}
            </v-chip>
            <v-chip v-else color="success" small dark label>
              <v-icon left x-small>mdi-check</v-icon>
              ว่าง
            </v-chip>
          </template>

          <template v-slot:item.id_position="{ item }">
            <span class="font-weight-bold primary--text">{{
              item.id_position
            }}</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="amber darken-2"
                  @click.stop="man_powerEdit(item.id_m)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>แก้ไข</span>
            </v-tooltip>
          </template>

          <template v-slot:item.action_s="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="error"
                  @click.stop="man_powerDelete(item.id_m)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>ลบ</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </base-material-card>

      <v-dialog v-model="addman_powerdialog" persistent max-width="600px">
        <v-card class="rounded-lg">
          <v-toolbar color="primary" dark flat>
            <v-icon left>mdi-briefcase-plus</v-icon>
            <v-toolbar-title>เพิ่มข้อมูลอัตรากำลัง</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="addman_powerdialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <v-form ref="addman_powerform" lazy-validation>
              <v-autocomplete
                v-model="addman_power.college_code"
                :items="colleges"
                item-text="college_name"
                item-value="college_code"
                label="สถานศึกษา"
                outlined
                rounded
                dense
                prepend-inner-icon="mdi-school"
                required
                :rules="[v => !!v || 'กรุณาเลือกสถานศึกษา']"
              ></v-autocomplete>

              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="addman_power.id_position"
                    label="เลขที่ตำแหน่ง"
                    outlined
                    rounded
                    dense
                    prepend-inner-icon="mdi-numeric"
                    required
                    :rules="[v => !!v || 'กรุณาระบุเลขที่ตำแหน่ง']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="addman_power.position"
                    :items="userstatus"
                    item-text="user_status_name"
                    item-value="user_status_name"
                    label="ประเภทตำแหน่ง"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || 'กรุณาเลือกประเภท']"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-text-field
                v-model="addman_power.case_vacancy"
                label="กรณี/สาเหตุตำแหน่งว่าง"
                placeholder="เช่น เกษียณอายุราชการ, ลาออก, ย้าย"
                outlined
                rounded
                dense
                prepend-inner-icon="mdi-text-box-outline"
                required
                :rules="[v => !!v || 'กรุณาระบุสาเหตุ']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end pa-4 grey lighten-5">
            <v-btn text @click="addman_powerdialog = false">ยกเลิก</v-btn>
            <v-btn color="primary" depressed @click="addman_powerSubmit"
              >บันทึกข้อมูล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editman_powerdialog" persistent max-width="600px">
        <v-card class="rounded-lg">
          <v-toolbar color="warning darken-1" dark flat>
            <v-icon left>mdi-pencil-box</v-icon>
            <v-toolbar-title>แก้ไขข้อมูลอัตรากำลัง</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="editman_powerdialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <v-form ref="editman_powerform" lazy-validation>
              <v-autocomplete
                v-model="editman_power.college_code"
                :items="colleges"
                item-text="college_name"
                item-value="college_code"
                label="สถานศึกษา"
                outlined
                rounded
                dense
                required
                :rules="[v => !!v || '']"
              ></v-autocomplete>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editman_power.id_position"
                    label="เลขที่ตำแหน่ง"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || '']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="editman_power.position"
                    :items="userstatus"
                    item-text="user_status_name"
                    item-value="user_status_name"
                    label="ประเภทตำแหน่ง"
                    outlined
                    rounded
                    dense
                    required
                    :rules="[v => !!v || '']"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-text-field
                v-model="editman_power.case_vacancy"
                label="กรณี"
                outlined
                rounded
                dense
                required
                :rules="[v => !!v || '']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end pa-4 grey lighten-5">
            <v-btn text @click="editman_powerdialog = false">ยกเลิก</v-btn>
            <v-btn color="warning" depressed @click="editman_powerSubmit"
              >บันทึกการแก้ไข</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteman_powerdialog" persistent max-width="450px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-delete-alert</v-icon>
            ยืนยันการลบ
          </v-card-title>
          <v-card-text>
            <div class="subtitle-1">
              คุณต้องการลบข้อมูลตำแหน่งนี้ใช่หรือไม่?
            </div>
            <v-alert dense outlined color="grey darken-1" class="mt-2 caption">
              {{ editman_power.college_name }} <br />
              เลขที่ตำแหน่ง: {{ editman_power.id_position }}
            </v-alert>
            <v-form ref="deleteman_powerform"></v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteman_powerdialog = false">ยกเลิก</v-btn>
            <v-btn color="error" depressed @click="deleteman_powerSubmit"
              >ยืนยันลบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="ClearMan_powerdialog" persistent max-width="450px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-alert-decagram</v-icon>
            ล้างข้อมูลทั้งหมด
          </v-card-title>
          <v-card-text>
            <div class="subtitle-1 error--text font-weight-bold">
              คำเตือน: การกระทำนี้ไม่สามารถกู้คืนได้
            </div>
            <div class="body-2 mt-2">
              ระบบจะลบข้อมูลตำแหน่งว่างทั้งหมดออกจากฐานข้อมูล
            </div>
            <v-form ref="ClearMan_powerform"></v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="ClearMan_powerdialog = false">ยกเลิก</v-btn>
            <v-btn color="error" depressed @click="ClearMan_powerSubmit"
              >ยืนยันล้างข้อมูล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="man_powerCSVdialog" persistent max-width="500px">
        <v-card class="rounded-lg">
          <v-toolbar color="indigo" dark flat>
            <v-icon left>mdi-file-import</v-icon>
            <v-toolbar-title>นำเข้าไฟล์ CSV</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="man_powerCSVdialog = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pt-6">
            <v-btn
              block
              outlined
              color="info"
              class="mb-4"
              to="/admin/man_power_import/"
              target="_blank"
            >
              <v-icon left>mdi-download</v-icon> ดาวน์โหลดแบบฟอร์มตัวอย่าง
            </v-btn>

            <v-file-input
              v-model="file2"
              accept=".csv"
              label="เลือกไฟล์ .csv"
              outlined
              rounded
              dense
              prepend-icon="mdi-paperclip"
              show-size
            ></v-file-input>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="man_powerCSVdialog = false">ยกเลิก</v-btn>
            <v-btn color="indigo" depressed dark @click="csvManpowerSubmit"
              >นำเข้าข้อมูล</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        top
        right
        rounded="pill"
      >
        <v-icon left>{{ snackbar.icon }}</v-icon> {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx"; // ต้องรัน npm install xlsx

export default {
  components: { Movementmenu },
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      search: "",
      file2: null,

      // Dialog States
      addman_powerdialog: false,
      editman_powerdialog: false,
      deleteman_powerdialog: false,
      ClearMan_powerdialog: false,
      man_powerCSVdialog: false,

      // Data
      man_powers: [],
      addman_power: {},
      editman_power: {},
      colleges: [],
      userstatus: [],
      data_syslog: {},

      snackbar: { show: false, color: "", icon: "", text: "" },

      headers: [
        { text: "รหัสสถานศึกษา", align: "left", value: "college_code" },
        { text: "สถานศึกษา", align: "left", value: "college_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "อัตราว่าง", align: "center", value: "num_position" },
        { text: "เลขที่ตำแหน่ง", align: "center", value: "id_position" },
        { text: "ตำแหน่ง", align: "left", value: "position" },
        { text: "กรณี", align: "left", value: "case_vacancy" },
        { text: "สถานะจอง", align: "center", value: "status_booking" },
        {
          text: "รหัสสถานศึกษาเดิม",
          align: "left",
          value: "college_code_self"
        }, // Optional display
        { text: "วิทยาลัยเดิม", align: "left", value: "college_name_self" }, // Optional display
        { text: "เจ้าของเดิม", align: "left", value: "id_card" }, // Optional display
        { text: "ชื่อเจ้าของเดิม", align: "left", value: "frist_name" }, // Optional display
        { text: "นามสกุลเจ้าของเดิม", align: "left", value: "last_name" }, // Optional display
        { text: "แก้ไข", align: "center", value: "actions", sortable: false },
        { text: "ลบ", align: "center", value: "action_s", sortable: false }
      ]
    };
  },

  computed: {
    stats() {
      const total = this.man_powers.length;
      const booked = this.man_powers.filter(x => x.status_booking).length;
      const vacant = total - booked;
      const teacher = this.man_powers.filter(
        x => x.position && x.position.includes("ครู")
      ).length;
      return { total, booked, vacant, teacher };
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return `${dd}/${mm}/${yyyy}/${time}`;
    },
    time_stamp() {
      return Date.now();
    }
  },

  async mounted() {
    await this.man_powerQueryAll();
    this.fetchDropdownData();
  },

  methods: {
    async fetchDropdownData() {
      let resCol = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = resCol.data;

      let resUserStatus = await this.$http.post(
        "crud_user_status.php?crud=read",
        { ApiKey: this.ApiKey }
      );
      this.userstatus = resUserStatus.data;
    },

    async man_powerQueryAll() {
      this.loading = true;
      try {
        let result = await this.$http.post("man_power.php", {
          ApiKey: this.ApiKey
        });
        this.man_powers = result.data;
      } finally {
        this.loading = false;
      }
    },

    // --- EXCEL EXPORT ---
    exportToExcel() {
      const data = this.man_powers.map(item => ({
        รหัสสถานศึกษา: item.college_code,
        สถานศึกษา: item.college_name,
        จังหวัด: item.province_name,
        เลขที่ตำแหน่ง: item.id_position,
        ตำแหน่ง: item.position,
        กรณีว่าง: item.case_vacancy,
        สถานะการจอง: item.status_booking || "ว่าง",
        รหัสสถานศึกษาเดิม: item.college_code_self || "",
        วิทยาลัยเดิม: item.college_name_self || "",
        รหัสเจ้าของเดิม: item.id_card || "",
        ชื่อเจ้าของเดิม: `${item.frist_name || ""} ${item.last_name || ""}`
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Manpower");
      XLSX.writeFile(wb, `Manpower_Report_${this.time_stamp}.xlsx`);
    },

    // --- CRUD Operations ---
    async man_powerAdd() {
      this.addman_power = {};
      this.addman_powerdialog = true;
    },

    async addman_powerSubmit() {
      if (this.$refs.addman_powerform.validate()) {
        this.addman_power.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "man_power.insert.php",
          this.addman_power
        );
        if (result.data.status == true) {
          this.showSnackbar("บันทึกข้อมูลเรียบร้อย", "success");
          this.logSystem(
            "insert",
            this.addman_power.id_position + ":" + this.addman_power.college_code
          );
          this.man_powerQueryAll();
          this.addman_powerdialog = false;
        } else {
          this.showSnackbar("บันทึกข้อมูลผิดพลาด", "error");
        }
      }
    },

    async man_powerEdit(id_m) {
      let result = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        id_m: id_m
      });
      this.editman_power = result.data;
      this.editman_powerdialog = true;
    },

    async editman_powerSubmit() {
      if (this.$refs.editman_powerform.validate()) {
        this.editman_power.ApiKey = this.ApiKey;
        let result = await this.$http.post(
          "man_power.update.php",
          this.editman_power
        );
        if (result.data.status == true) {
          this.showSnackbar("แก้ไขข้อมูลเรียบร้อย", "success");
          this.logSystem(
            "update",
            `${this.editman_power.id_position} : ${this.editman_power.college_code}`
          );
          this.man_powerQueryAll();
          this.editman_powerdialog = false;
        } else {
          this.showSnackbar("แก้ไขข้อมูลผิดพลาด", "error");
        }
      }
    },

    async man_powerDelete(id_m) {
      let result = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        id_m: id_m
      });
      this.editman_power = result.data;
      this.deleteman_powerdialog = true;
    },

    async deleteman_powerSubmit() {
      // Assuming validation check passed or not needed for delete confirmation
      this.editman_power.ApiKey = this.ApiKey;
      let result = await this.$http.post(
        "man_power.delete.php",
        this.editman_power
      );
      if (result.data.status == true) {
        this.showSnackbar("ลบข้อมูลเรียบร้อย", "success");
        this.logSystem(
          "delete",
          `${this.editman_power.id_position} : ${this.editman_power.college_code}`
        );
        this.man_powerQueryAll();
        this.deleteman_powerdialog = false;
      } else {
        this.showSnackbar("ลบข้อมูลผิดพลาด", "error");
      }
    },

    // --- Other Actions ---
    async man_powerReplace() {
      this.loading = true;
      let result = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        man_powerCheck: "Ok"
      });
      this.man_powers = result.data;
      this.loading = false;
      this.showSnackbar("ตรวจสอบข้อมูลซ้ำเรียบร้อย", "info");
    },

    async man_powerCSV() {
      this.man_powerCSVdialog = true;
    },

    async csvManpowerSubmit() {
      if (this.file2) {
        let formData = new FormData();
        let filename = this.time_stamp + ".manpower.csv";
        formData.append("file", this.file2);
        formData.append("filename", "../HRvecfiles/" + filename);
        formData.append("ApiKey", this.ApiKey);

        let result = await this.$http.post("man_powercsv.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if (result.data.status == true) {
          this.showSnackbar("นำเข้าข้อมูลเรียบร้อย", "success");
          this.man_powerQueryAll();
          this.man_powerCSVdialog = false;
        } else {
          this.showSnackbar("นำเข้าข้อมูลผิดพลาด", "error");
        }
      }
    },

    async man_powerClear() {
      this.ClearMan_powerdialog = true;
    },

    async ClearMan_powerSubmit() {
      this.editman_power = { ApiKey: this.ApiKey }; // Clear payload
      let result = await this.$http.post(
        "man_power.clear.php",
        this.editman_power
      );
      if (result.data.status == true) {
        this.showSnackbar("ล้างข้อมูลเรียบร้อย", "success");
        this.logSystem("Clear", "All Data");
        this.man_powerQueryAll();
        this.ClearMan_powerdialog = false;
      } else {
        this.showSnackbar("ล้างข้อมูลผิดพลาด", "error");
      }
    },

    // --- Helper: Logging ---
    async logSystem(event, detail) {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      this.data_syslog = {
        ApiKey: this.ApiKey,
        user_account: userSession.user_name || "unknown",
        event_log: event,
        page_log: "man_power",
        table_log: "man_power",
        detail_log: detail,
        date_times: this.date_today_log
      };
      await this.$http.post("data_syslog.insert.php", this.data_syslog);
    },

    showSnackbar(text, color) {
      this.snackbar = {
        show: true,
        text,
        color,
        icon: color === "success" ? "mdi-check-circle" : "mdi-alert"
      };
    }
  }
};
</script>

<style scoped>
.custom-table >>> thead th {
  font-weight: 600 !important;
  color: #333 !important;
  background-color: #f8f9fa;
}
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}
.bg-white {
  background-color: white;
}
</style>
